module.exports = __webpack_public_path__ + "static/media/ico_me_melia.01b7b609.svg";